import DocumentDetailIvend from './DocumentDetailIvend'

export default DocumentDetailIvend
